import React, { Component } from 'react';
import './style.css';
import { Trans, translate } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

class Story extends Component {
  constructor(props) {
    super(props);
    this.state = { story: '' };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    event.target.style.height = 'auto';
    event.target.style.height = `${event.target.scrollHeight}px`;
    this.setState({
      story: event.target.value
    });
  }

  render() {
    const {
      t,
      i18n: { language: lang }
    } = this.props;
    let description;
    const name1 = this.props.pair.projectObjects[0].name;
    const name2 = this.props.pair.projectObjects[1].name;

    if (this.props.adjective === 'similar') {
      description = (
        <Trans i18nKey="similarStory">
          Please describe what you associate with <b>"{{ name1 }}"</b> and{' '}
          <b>"{{ name2 }}"</b>. Describe the difference in a short story.
        </Trans>
      );
    }

    if (this.props.adjective === 'different') {
      description = (
        <Trans i18nKey="differentStory">
          Please describe what you associate with <b>"{{ name1 }}"</b> and{' '}
          <b>"{{ name2 }}"</b>. Describe the commonality in a short story.
        </Trans>
      );
    }

    let skip = () => {
      const nextPath = this.props.skip(this.props.pair);
      if (this.props.history.canGo(1)) {
        this.props.history.goForward();
      } else {
        this.props.history.push(nextPath);
      }
    };

    return (
      <div className="card-body">
        <h1 className="h6 text-muted">{this.props.completionStatus}</h1>
        <div className="question">{description}</div>
        <div className="text-input-container">
          <textarea
            autoFocus
            className="text-input"
            placeholder={t('Story in 1-3 phases...')}
            rows="3"
            onChange={this.handleChange}
            value={this.state.story}
            spellCheck
            lang={lang}
          />
        </div>
        <div className="actions">
          <button className="btn btn-link" onClick={skip}>
            Skip Question
          </button>
          <Link to={this.props.url + '/' + this.props.adjective}>
            <button
              className="btn btn-primary btn-round btn-next"
              onClick={() => this.props.save(this.state.story)}
              disabled={!this.state.story}
            >
              Next <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default translate('translations')(withRouter(Story));



// WEBPACK FOOTER //
// ./src/comparison-new/components/Pair/story.js